<script >
import { computed, onBeforeMount, ref } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  theme: {
    type: String
  },
  logo: {
    type: String
  },
  customLogo: {
    type: String
  },
  title: {
    type: String
  },
  text: {
    type: String
  },
  copyright: {
    type: String
  },
  // 兼容旧数据，默认是关闭
  showWhenWithCommonFooter: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useLang,
    usePageType,
    useDark,
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    langText
  } = useLang();
  const {
    isPC
  } = usePageType();
  const props = __props;
  const logoStyle = computed(() => {
    if (props.logo === 'custom' && props.customLogo) {
      return {
        backgroundImage: `url(${props.customLogo})`
      };
    }
  });

  // 是否有公共头尾
  const {
    isPreRender
  } = useEnv();
  const footerVisible = ref(true);
  !isPreRender && onBeforeMount(() => {
    // 有官网尾部，且配置了不展示，则隐藏
    if (window?._params?.payload?.officialTmpl?.getFooter && !props.showWhenWithCommonFooter) {
      footerVisible.value = false;
    }
  });

  // 自动黑白肤
  const {
    isAuto: isSkinAuto,
    isDark: isSkinDark
  } = useDark?.(props.theme === 'dark') || {
    isDark: props.theme === 'dark'
  };
  return {
    langText,
    isPC,
    logoStyle,
    footerVisible,
    isSkinAuto,
    isSkinDark
  };
};
export default __sfc_main;
</script>
<template>
    <div
        v-if="footerVisible"
        :class="[
            'footer-container',
            langText,
            {
                'client-skin-adapt': isSkinAuto,
                dark: isSkinDark,
                pc: isPC,
            }
        ]"
    >
        <div :class="['footer-logo', logo]" :style="logoStyle"></div>
        <div v-if="title" class="footer-title" v-html="title"></div>
        <div v-if="text" class="footer-text" v-html="text"></div>
        <div v-if="copyright" class="footer-copyright" v-html="copyright"></div>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
